import React from 'react';
import { observer } from 'mobx-react';
import { yupResolver } from '@hookform/resolvers/yup';
import { FormProvider, useForm } from 'react-hook-form';
import * as yup from 'yup';

import {
  Center,
  Box,
  Heading,
  Text,
  Button,
  Stack,
  Flex,
  StackDivider,
  Container,
} from '@chakra-ui/react';

import { useStores } from 'hooks/useStores';
import Input from 'components/Form/Input';

const schema = yup.object().shape({
  login: yup.string().required(),
  password: yup.string().required(),
});

const SingInPage = () => {
  const {
    authStore: { isLoading, login },
  } = useStores();


  const methods = useForm({ resolver: yupResolver(schema) });
  const { handleSubmit } = methods;

  return (
    <div>
      <Container maxW="container.xl">
        <Center
          px={{
            base: 0,
            md: 12,
          }}
          py={8}
        >
          <Box
            bg="bg"
            rounded={'lg'}
            p={8}
            maxW={{ base: '100%', md: '70%', lg: '50%' }}
            borderColor="gray.300"
            borderWidth={1}
          >
            <Flex flex={1} flexDirection="column">
              <Heading fontSize="2xl" color="DNGBlue">
                Welcome
              </Heading>
              <FormProvider {...methods}>
                <form onSubmit={handleSubmit(login)}>

                  <Input name="login" label="Login" autoComplete="username" />
                  <Input name="password" label="Login" type="password" autoComplete="current-password" />

                  <Button
                    type="submit"
                    w="full"
                    variant="outline"
                    colorScheme="blue"
                    isLoading={isLoading}
                  >
                    Sign In
                  </Button>
                </form>
              </FormProvider>
            </Flex>
          </Box>
        </Center>
      </Container>
    </div>
  );
};

export default observer(SingInPage);
